import { Component } from '@angular/core';
import { KeyHandlerDirective } from '../../../directives/key-handler.directive';
import { MatDialogRef } from '@angular/material/dialog';
import { FolderResource } from 'src/app/models/resource/folder.resource';

@Component({
    selector: 'lex-select-folder',
    templateUrl: './select-folder.component.html',
    styleUrls: ['./select-folder.component.scss'],
    standalone: false
})
export class SelectFolderComponent extends KeyHandlerDirective {

  constructor(private dialogRef: MatDialogRef<SelectFolderComponent>) {
    super();
  }

  folderClick(path: FolderResource[]) {
    this.dialogRef.close(path);
  }

  ok(): void {
    this.dialogRef.close();
  }
}
